module.exports = __webpack_public_path__ + "img/coverpic.923cfad6.jpg";